import React, { useEffect, useState } from "react";
import { Button, Spinner, Tab, Tabs } from "react-bootstrap";
import { createRoot } from "react-dom/client";

import { TextAreaInput } from "../../../shared/form/FormInput";
import { resultDetail, resultUpdate, runAssessmentClientList } from "../../../shared/settings/apiConfig";
import { getApi, postApi, putApi } from "../../../shared/services/apiHelper";
import './ResultScreen.scss';
import ReactMarkdown from 'react-markdown';
import CodeViewer from "../../../shared/components/CodeViewer";

const ResultScreen = (props) => {
    const [answerSheetHtmlContent, setAnswerSheetHtmlContent] = useState("");
    const [resultHtmlContent, setResultHtmlContent] = useState("");
    const [outcomeHtmlContent, setOutcomeHtmlContent] = useState("");
    const [notes, setNotes] = useState({ answernotes: "", resultnotes: "" });
    const [loading, setloading] = useState(false);
    const [message, setmessage] = useState({msg:"",type:""});
    const [clientData, setClientData] = useState("");
    
    useEffect(() => {
        getApi(resultDetail + props.match.params.resultid).then(response => {
            const data = response.data.data[0];
            setAnswerSheetHtmlContent(data['answers']);
            setResultHtmlContent(data['results']);
            setOutcomeHtmlContent(data['outcomes']);
            setNotes({
                answernotes: data['answernotes'] || "",
                resultnotes: data['resultnotes'] || ""
            });

            let payload = {
                filter: [{ field: 'id', value: data.runassessmentclientid, op: '=', join: "AND" }],
                page: { size: 1 }
            }

            postApi(runAssessmentClientList, payload).then(response => {
                setClientData(response.data.data[0]);
            }).catch((error) => {
            });
        }).catch((error) => {
        });

        return () => {}
    }, []);

    useEffect(() => {
        if ( answerSheetHtmlContent ) {
            const codeViewers = document.querySelectorAll('.codeviewer');
            codeViewers.forEach(element => {
                if ( element.textContent ) {
                    const root = createRoot(element);
                    root.render(
                        <CodeViewer code={element.textContent} language={typeof element.dataset.language === 'string' ? element.dataset.language.toLowerCase() : ''} />
                    );
                }
            });

            const codeReviewRecommendations = document.querySelectorAll('.ai-recommendations');
            codeReviewRecommendations.forEach(element => {
                if ( element.textContent ) {
                    const root = createRoot(element);
                    root.render(
                        <ReactMarkdown>{element.textContent}</ReactMarkdown>
                    );
                }
            });


        }
    }, [answerSheetHtmlContent]);

    const onChangeNotes = (name, value) => {
        setNotes(prevState => {
            prevState[name] = value;
            return {...prevState};
        });
    };
    useEffect(() => {
      if(message?.msg != "") {
        setTimeout(() => {
            setmessage({msg:"",type:""})
        }, 3000);
      }
    }, [message])
    

    const saveNotes = () => {
        setloading(true)
        const payload = { id: props.match.params.resultid, ...notes };
        putApi(resultUpdate, {data: payload}).then(response => {
            if(response?.data?.status == "success") {
                setmessage({ msg: "successfully updated" ,type:"success"})
            } else {
                setmessage({ msg: "Please try again and if issue persist contact Helpdesk" ,type:"fail"})
            }
            setloading(false)
        }).catch(error => {
            setmessage({ msg: "Please try again and if issue persist contact Helpdesk" ,type:"fail"}) //temp error
        });
    };

    return (
        <div id="resultscreen">
            <div className="d-flex w-100 align-items-center py-2 px-3">
                <div className='w-50 d-flex align-items-center clickable gap-2' onClick={()=>{props.history.goBack();}} >
                    <img style={{width: '1.5rem'}} src={`${process.env.PUBLIC_URL}/static/images/back.png`} alt={"back"} />
                    <text className='header my-1'>Result</text>
                </div>
                <div className='d-flex w-80 justify-content-end align-items-center gap-5 '>
                    <Button onClick={()=>{
                      const printableElements = document.getElementById('resultcont').innerHTML;
                      const orderHtml = '<html><head><title></title></head><body>' + printableElements + '</body></html>';
                      const oldPage = document.body.innerHTML;
                      document.body.innerHTML = orderHtml;
                      window.print();
                      window.location.reload();
                      document.body.innerHTML = oldPage;
                    }}>Print</Button>

                </div>
            </div>
            <div className="d-flex p-3 justify-content-between">
                <div className="d-flex gap-2">
                    <div className="font-weight-bold">Assesse: </div>
                    <div>{clientData.firstname + " " + clientData.lastname} | {clientData.clientnumber} | {clientData.subjectname}</div>
                </div>
                {/* <div className="d-flex gap-2">
                    <div className="font-weight-bold">Score: </div>
                    <div>{clientData.score}</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="font-weight-bold">Attempts: </div>
                    <div>{clientData.attempts}</div>
                </div> */}
            </div>
            {/* <div id="answersheetcontainer" style={{ overflowWrap: "break-word", wordBreak: "break-all", overflow: "hidden" }} className="border-bottom" dangerouslySetInnerHTML={{ __html: answerSheetHtmlContent }} /> */}
            <Tabs defaultActiveKey="answers">
                <Tab eventKey="answers" title="Answers">
                    <div id="answersheetcontainer" style={{ overflowWrap: "break-word", wordBreak: "break-all", overflow: "hidden" }} className="border-bottom" dangerouslySetInnerHTML={{ __html: answerSheetHtmlContent }} />
                    <div className="d-flex flex-column align-items-center p-3 gap-2">
                        <TextAreaInput style={{"minHeight": "5rem"}} name={'answernotes'} placeholder={'Enter Answer Notes'} value={notes.answernotes} onChange={(event) => onChangeNotes('answernotes', event.target.value)} ignoreDefaultErrorSpace />
                        {message.msg && <div className={`p-3 text-${message.type == 'success' ? 'success' : 'danger'}`}>{message.msg}</div>}
                        <Button disabled={!notes.answernotes} onClick={saveNotes}>Save Answer Notes {loading ? <Spinner className='ms-2' as="span" animation="border" role="status" aria-hidden="true" /> : null}</Button>
                    </div>
                </Tab>
                <Tab eventKey="results" title="Results">
                    <div id="resultcont" style={{ overflowWrap: "break-word", wordBreak: "break-all", overflow: "hidden" }} className="border-bottom" dangerouslySetInnerHTML={{ __html: resultHtmlContent }} />
                    <div className="d-flex flex-column align-items-center p-3 gap-2">
                        <TextAreaInput style={{"minHeight": "5rem"}} name={'resultnotes'} placeholder={'Enter Result Notes'} value={notes.resultnotes} onChange={(event) => onChangeNotes('resultnotes', event.target.value)} ignoreDefaultErrorSpace />
                        <Button disabled={!notes.resultnotes} onClick={saveNotes}>Save Result Notes {loading ? <Spinner className='ms-2' as="span" animation="border" role="status" aria-hidden="true" /> : null}</Button>
                    </div>
                </Tab>
                <Tab eventKey="outcomes" title="Outcomes">
                    <div id="outcomecont" style={{ overflowWrap: "break-word", wordBreak: "break-all", overflow: "hidden" }} className="border-bottom" dangerouslySetInnerHTML={{ __html: outcomeHtmlContent }} />
                    {/* <div className="d-flex flex-column align-items-center p-3 gap-2">
                        <TextAreaInput style={{"minHeight": "5rem"}} name={'outcomenotes'} placeholder={'Enter Outcome Notes'} value={notes.outcomenotes} onChange={(event) => onChangeNotes('outcomenotes', event.target.value)} ignoreDefaultErrorSpace />
                        <Button disabled={!notes.outcomenotes} onClick={saveNotes}>Save Result Notes {loading ? <Spinner className='ms-2' as="span" animation="border" role="status" aria-hidden="true" /> : null}</Button>
                    </div> */}
                </Tab>
            </Tabs>
        </div>
    )
}

export default ResultScreen;
